import React, { FC, useMemo } from 'react';

import { Box, Stack, useDesktop, useMediaSwitch } from 'Modules/ui3';

import { getNewsSlidesArray, newsGlider } from './utils';
import { NEWS_DOMAIN_PATH, NewsPaginationElement } from '../../api';
import { NewsSlide, NewsSlideProps } from '../NewsSlide';
import { SectionTitleH1 } from '../Titles';
import { NewsProps } from './types';
import { Slider } from '../Slider';
import { SliderControls } from '../SliderControls';
import { useSliderPagination } from '../Slider/utils';


export const News: FC<NewsProps> = React.memo(({ rowCount = 1, ...props }) => {
    const slidesViewCount = useMediaSwitch(3, 2, 1);
    const isDesktop = useDesktop();
    const { needShowElement, disableSlider, totalElements } =
        useSliderPagination<NewsPaginationElement>({
            elementsViewCount: slidesViewCount * rowCount,
            path: NEWS_DOMAIN_PATH,
        });

    const slides = useMemo(() => getNewsSlidesArray({
        elements: totalElements,
        rowCount,
        colCount: slidesViewCount,
    }), [totalElements, rowCount, slidesViewCount]);

    return (
        <Stack spacing={isDesktop ? 10 : 6} {...props}>
            <SectionTitleH1>Новости</SectionTitleH1>
            <Slider<NewsSlideProps>
                glider={newsGlider}
                slideComponent={NewsSlide}
                needShow={needShowElement}
                slidesData={slides}
                elementsViewCount={slidesViewCount}
                disabled={disableSlider}
            />
            <Box alignSelf='center'>
                <SliderControls
                    disabled={disableSlider}
                    glider={newsGlider}
                    slidesCount={slides.length}
                    elementsViewCount={slidesViewCount}
                    showNumbers
                />
            </Box>
        </Stack>
    );
});
